import React from "react";
import H2 from "@material-tailwind/react/Heading2";
import LeadText from '@material-tailwind/react/LeadText';
import H5 from "@material-tailwind/react/Heading5";
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';
import {Card, CardGroup, Row, Col} from 'react-bootstrap';
import { Container} from 'reactstrap';
import '../../App.css';
import programBook from '../../assets/images/contents/SCDS23-LATESTPROGRAMBOOK by18Jan23.pdf';
import qr_code from '../../assets/images/contents/SCDS2023-ProgramBook_QR_Code.svg';

function ProgramBook() {
    return (
      <div className="container max-w-8xl relative mx-auto">
        <Helmet>
          <title>The 7th International Conference on Soft Computing in Data Science 2023 (SCDS2023) - Program Book</title>
        </Helmet>
        <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
            <li class="breadcrumb-item "><Link to="/scds2023/">Information</Link></li>
            <li class="breadcrumb-item active" aria-current="page">ProgramBook</li>
          </ol>
        </nav>
          <div className="items-center flex flex-wrap">
              <div className="w-full lg:w-6/12 px-2 ml-auto mr-auto text-center">
                  <H2 color="dark">Program Book</H2>
              </div>

              <div style={{ textAlign:'justify', fontFamily: 'Verdana'}}>
                {/* <h2>Program Book</h2> */}
                <Container> 
                  <Row className="justify-content-md-left">  
                    <Col md="auto">
                      <Card>
                        <Card.Img width="50px" height="100px" src={qr_code} alt="qr code program book" /> 
                      </Card>             
                    </Col>
                  </Row>
                </Container>

                <br/>
                <p color="dark-200" style={{ textAlign:'justify'}}>                    
                  <p style={{ textAlign:'justify'}}>
                    You can download program book by scanning the QR code above or just <a href={programBook} target="blank">click here</a>.
                  </p>
                </p>   
                <p color="dark-200" style={{ textAlign:'justify'}}>                    
                  <p style={{ textAlign:'justify'}}>
                    All presenters can download this conference schedule here: <a href="https://edas.info/p29330" target="blank">https://edas.info/p29330</a>
                  </p>
                </p>   
                <p style={{ textAlign:'justify'}}><b>Notes:</b><br/>
                  Kuala Lumpur Time: Malaysia time (GMT+8)<br/>             
                </p>                          
    
              </div>
          </div>

  </div>
    );
}

export default ProgramBook;